// extracted by mini-css-extract-plugin
export var danger = "_2f-6";
export var lightPink = "_2f-a";
export var medium = "_2f-j";
export var nearSquare = "_2f-m";
export var neutralBlue = "_2f-8";
export var neutralYellow = "_2f-7";
export var noCapitalize = "_2f-1";
export var normal = "_2f-2";
export var pill = "_2f-0";
export var primary = "_2f-3";
export var primaryLight = "_2f-4";
export var shadow = "_2f-n";
export var small = "_2f-k";
export var solidBlack = "_2f-i";
export var solidGreen = "_2f-d";
export var solidLightBlue = "_2f-f";
export var solidNavy = "_2f-e";
export var solidOrange = "_2f-h";
export var solidPink = "_2f-g";
export var solidRed = "_2f-b";
export var solidWhite = "_2f-9";
export var solidYellow = "_2f-c";
export var success = "_2f-5";
export var xsmall = "_2f-l";